import { render, staticRenderFns } from "./B-3-2-2__BUPageEdit_Sec-NewsBanner+Video.vue?vue&type=template&id=2a6cf731&"
import script from "./B-3-2-2__BUPageEdit_Sec-NewsBanner+Video.vue?vue&type=script&lang=js&"
export * from "./B-3-2-2__BUPageEdit_Sec-NewsBanner+Video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VIcon,VRadio,VRadioGroup,VTextField,VTextarea})
